module.exports = __webpack_public_path__ + "static/media/beachball.e1630d19.svg";